import { render, staticRenderFns } from "./ErrorPopUp.vue?vue&type=template&id=3062c8dc&scoped=true&"
import script from "./ErrorPopUp.vue?vue&type=script&lang=js&"
export * from "./ErrorPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPopUp.vue?vue&type=style&index=0&id=3062c8dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062c8dc",
  null
  
)

export default component.exports